import {FC} from 'react'

import {Text} from '@/components/common/content/Text'
import {getClassAssistItemContent} from '@/content/classAssist'
import {Link, useTranslation} from '@/i18n'
import {theme} from '@/theme/theme'
import {ClassAssistItemOverviewData} from '@/utils/class-assist/types'
import {routeTo} from '@/utils/router'

import {ClassAssistOverviewLayout} from '../layout/ClassAssistOverviewLayout'
import {ClassAssistClassOverviewSection} from '../layout/ClassAssistOverviewSection'
// import {ClassAssistTrademarkExample} from '../types'
import {ClassAssistItemIpoTable} from './ClassAssistItemIpoTable'

type ClassAssistItemOverviewProps = {
  classCode: string
  item: ClassAssistItemOverviewData
  // tmExamples: ClassAssistTrademarkExample[]
}

export const ClassAssistItemOverview: FC<React.PropsWithChildren<ClassAssistItemOverviewProps>> = ({
  classCode,
  item,
  // tmExamples,
}) => {
  const {t} = useTranslation()
  const {
    overviewTitle,
    recommendedTitle,
    // examplesTitle,
    ipo,
    associatedTitle,
    associatedDescription,
  } = getClassAssistItemContent()

  return (
    <>
      <ClassAssistOverviewLayout title={t(overviewTitle, {itemName: item.name})}>
        {item.associatedSectors.length ? (
          <ClassAssistClassOverviewSection title={t(recommendedTitle)}>
            <ul>
              {item.associatedSectors.map(({sector, industry, sectorSlug, industrySlug}) => (
                <li key={`${industry}-${sector}`} className="item">
                  <Text>
                    <Link
                      href={routeTo.classAssist.industry(industrySlug, sectorSlug)}
                      prefetch={false}
                      legacyBehavior
                    >
                      <a className="underline">{`${industry} - ${sector}`}</a>
                    </Link>
                  </Text>
                </li>
              ))}
            </ul>
          </ClassAssistClassOverviewSection>
        ) : null}
        {/* TODO show this section when the Hall of fame will be ready */}
        {/* <ClassAssistClassOverviewSection title={t(examplesTitle)}>
          <ul>
            {tmExamples.map(({name, description, linkHref}) => (
              <li key={name} className="item">
                <Text>
                  <Link href={linkHref}>
                      <Text className="underline" element="span">
                        {name}
                      </Text>
                  </Link>
                  {description && ` - ${description}`}
                </Text>
              </li>
            ))}
          </ul>
        </ClassAssistClassOverviewSection> */}
        <ClassAssistClassOverviewSection title={t(ipo.title)} description={t(ipo.description)}>
          <ClassAssistItemIpoTable itemMap={item.itemMap} />
        </ClassAssistClassOverviewSection>
        {item.associatedItems.length > 0 && (
          <ClassAssistClassOverviewSection
            title={t(associatedTitle)}
            description={t(associatedDescription)}
          >
            <ul>
              {item.associatedItems.map(({name, slug}) => (
                <li key={slug} className="item">
                  <Text>
                    <Link
                      href={routeTo.classAssist.class(classCode, slug)}
                      prefetch={false}
                      legacyBehavior
                    >
                      <a className="underline">{name}</a>
                    </Link>
                  </Text>
                </li>
              ))}
            </ul>
          </ClassAssistClassOverviewSection>
        )}
      </ClassAssistOverviewLayout>

      <style jsx>{`
        .item {
          list-style-type: disc;
          margin-left: ${theme.spacing[4]};
        }

        .item + .item {
          margin-top: ${theme.spacing[2]};
        }
      `}</style>
    </>
  )
}
